import { render, staticRenderFns } from "./OsCard.vue?vue&type=template&id=c3aede86&scoped=true&"
import script from "./OsCard.vue?vue&type=script&lang=js&"
export * from "./OsCard.vue?vue&type=script&lang=js&"
import style0 from "./OsCard.vue?vue&type=style&index=0&id=c3aede86&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3aede86",
  null
  
)

export default component.exports